import type { FormState } from 'react-hook-form';

import type { UserFormData } from '../hooks/useUserFormValidation';

/**
 * Which of the fields `userUpdate` can write were actually edited, relative to
 * the values the form loaded with.
 */
export type UserFormChangedFields = {
  name: boolean;
  email: boolean;
  phone: boolean;
  locale: boolean;
  isTest: boolean;
  supplier: boolean;
  supportLogin: boolean;
  orderPreferences: boolean;
};

type UserFormDirtyFields = FormState<UserFormData>['dirtyFields'];

export const toChangedFields = (
  dirtyFields: UserFormDirtyFields
): UserFormChangedFields => ({
  name: !!dirtyFields.name,
  email: !!dirtyFields.email,
  phone: !!dirtyFields.phone,
  locale: !!dirtyFields.locale,
  isTest: !!dirtyFields.isTest,
  supplier: !!dirtyFields.supplier,
  supportLogin: !!dirtyFields.supportLogin,
  // react-hook-form tracks the nested preference fields individually, but the
  // mutation carries orderPreference as one object — any nested edit counts.
  orderPreferences: Object.values(dirtyFields.orderPreferences ?? {}).some(
    Boolean
  ),
});
